import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus, TypeCategory } from '../../enum';

@Component({
  selector: 'app-add-update-account-type',
  templateUrl: './add-update-account-type.component.html',
  styleUrls: ['./add-update-account-type.component.scss'],
  standalone: false,
})
export class AddUpdateAccountTypeComponent implements OnInit {
  isVisibleaccountTypeDrawer = true;
  accountTypeDrawerTitle = 'Add Account Type';
  isLoadingUpload = false;
  isLoadingOne = false;
  darkColorStyle: any;
  lightColorValidationColor: any;
  darkColorValidationColor: any;
  lightColorStyle: any;
  uploadResult: any = null;
  uploadFlag: any = false;
  @Output() hideTypeDrawer = new EventEmitter();
  @Input() selectedTypeData: any;
  @Input() SelectedTypeCategory: any;
  url: any;
  deleteIcon: any;
  userDetails: any;
  get TypeCategory() {
    return TypeCategory;
  }

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.accountTypeForm_fb();
  }

  ngOnInit(): void {
    if (this.selectedTypeData != null) {
      this.accountTypeDrawerTitle =
        'Edit ' +
        TypeCategory[this.SelectedTypeCategory] +
        ' Type (' +
        this.selectedTypeData.name +
        ')';
      this._fS.accountTypeForm.patchValue({
        accountTypeName: this.selectedTypeData.name,
        isActive: this.selectedTypeData.status == 0 ? false : true,
      });
      this.lightColorStyle = this._fS.accountTypeForm.value.color;
    } else {
      this.accountTypeDrawerTitle =
        'Add ' + TypeCategory[this.SelectedTypeCategory] + ' Type';
    }
  }

  applyColorlightColor() {
    this.lightColorStyle = this._fS.accountTypeForm.value.color;
  }

  //cancel update Agency
  handleCancel(data?: any) {
    this.isVisibleaccountTypeDrawer = false;
    this.hideTypeDrawer.emit({
      hide: this.isVisibleaccountTypeDrawer,
      data: data ? data : null,
    });
  }

  //add/update Agency
  handleOk() {
    if (this._fS.accountTypeForm.valid) {
      const formValue = this._fS.accountTypeForm.value;
      var accountTypeBody = {
        id: this.selectedTypeData != null ? this.selectedTypeData.id : null,
        name: formValue.accountTypeName.trim(),
        status: formValue.isActive ? 1 : 0,
        typeCategory: this.SelectedTypeCategory,
      };
      if (this.selectedTypeData) {
        this.updateAccountTypeData(accountTypeBody);
      } else {
        this.addAccountTypeData(accountTypeBody);
      }
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.accountTypeForm);
    }
  }

  //api call to add/update agency
  updateAccountTypeData(accountTypeBody: any) {
    this.isLoadingOne = true;
    // accountTypeBody = JSON.stringify(accountTypeBody)
    this._cpS.UpdateAccountType(accountTypeBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
  //api call to add/update agency
  addAccountTypeData(accountTypeBody: any) {
    this.isLoadingOne = true;
    // accountTypeBody = JSON.stringify(accountTypeBody)
    this._cpS.AddAccountType(accountTypeBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
}
